import {FilterType} from '/enum/filterType.enum';

import {FilterOptionProps} from '../MyTeamsContent.types';

import {useFrontlineFilter} from './useFrontlineFilter';
import {useLandingFilters} from './useLandingFilters';
import {useMyTeamsContext} from './useMyTeamsContext';
import {useMyTeamsFilterCount} from './useMyTeamsFilterCount';
import {useMyTeamsFilterModal} from './useMyTeamsFilterModal';
import {useMyTeamsFilters} from './useMyTeamsFilters';

type Props = {
  reportHeading?: string;
  ffTeamsOrgSR: boolean;

  initialTab?: 'my-teams' | 'watchlist';

  defaultNewCoachesKey: string;
  defaultNewCoachesValue: string;

  effectiveLastPaidRank: string;
  effectiveHighestAchievedRank: string;
  effectiveCoachCurrentRank: string;
  effectiveUserId: string;
};

export const useMyTeamsFiltersController = ({
  reportHeading,
  ffTeamsOrgSR,
  initialTab = 'my-teams',
  defaultNewCoachesKey,
  defaultNewCoachesValue,
  effectiveLastPaidRank,
  effectiveHighestAchievedRank,
  effectiveCoachCurrentRank,
  effectiveUserId,
}: Props) => {
  const {filtersRedux} = useMyTeamsContext();

  const optionSelected = (id: string, type: FilterType) => {
    const updateSelected = (options: FilterOptionProps[]) =>
      options.map(option => ({
        ...option,
        selected: option.id === id,
      }));

    if (type === FilterType.NEW_COACHES) {
      filters.updateCurrentTabFilters({
        newCoachesOptions: updateSelected(
          filters.currentFilters.newCoachesOptions ?? [],
        ),
      });
    }

    if (type === FilterType.FIBC) {
      filters.updateCurrentTabFilters({
        fibcOptions: updateSelected(filters.currentFilters.fibcOptions ?? []),
      });
    }
  };

  const filters = useMyTeamsFilters({
    ffTeamsOrgSR,
    optionSelected,
    initialTab,
  });

  const filterCount = useMyTeamsFilterCount({
    currentFilters: filters.currentFilters,
    defaultNewCoachesValue,
    ffTeamsOrgSR,
  });

  const {toggleFrontlineFilter} = useFrontlineFilter({
    frontlineOnly: filters.currentFilters.frontlineOnly ?? false,
    bonusOptions: filters.currentFilters.bonusOptions,
    closeToNextRank: filters.currentFilters.closeToNextRank,

    defaultNewCoachesKey,
    defaultNewCoachesValue,

    ffTeamsOrgSR,

    effectiveLastPaidRank,
    effectiveHighestAchievedRank,
    effectiveCoachCurrentRank,
    effectiveUserId,

    updateCurrentTabFilters: filters.updateCurrentTabFilters,
  });

  const modal = useMyTeamsFilterModal({
    rankOptions: filters.currentFilters.rankOptions,
    newCoachesOptions: filters.currentFilters.newCoachesOptions,
    fibcOptions: filters.currentFilters.fibcOptions,
    bonusOptions: filters.currentFilters.bonusOptions,
    filtersRedux,
    updateCurrentTabFilters: filters.updateCurrentTabFilters,
  });

  useLandingFilters({
    reportHeading,
    ffTeamsOrgSR,
    updateTabFilters: filters.updateTabFilters,
    currentFilters: filters.currentFilters,
  });

  return {
    ...filters,
    filterCount,
    toggleFrontlineFilter,
    ...modal,
  };
};
